module.exports = __webpack_public_path__ + "static/img/x_smtj.8ff136e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x_smtj.png
// module id = jbvo
// module chunks = 1